// extracted by mini-css-extract-plugin
export default {"titleSection":"LandingPageHeader_titleSection__AH+hv","title":"LandingPageHeader_title__wdya2","explanation":"LandingPageHeader_explanation__La7BL"};